import { memo, useMemo } from 'react';
import { useTranslation } from '@aimsos/i18n';

import { getFirstName } from '../../utils/memberDisplay';
import { buildDraft, summarizeDraft } from '../../utils/permissionTree';
import PermissionCounter from '../shared/PermissionCounter';
import { PermissionTree } from '../shared/PermissionTree';

/**
 * Read view of an expanded studio: the counter and the permission tree with read-only switches,
 * source tags, Partial badges and level suffixes.
 *
 * @param {object} props
 * @param {object} props.studio UI studio (see `useMemberStudios`)
 * @param {string} props.memberName
 */
const StudioRowExpanded = ({ studio, memberName }) => {
  const { t } = useTranslation('people-access');
  const draft = useMemo(() => buildDraft(studio.tree, studio.grants), [studio.tree, studio.grants]);
  const { direct, fromRoles } = useMemo(() => summarizeDraft(draft), [draft]);

  if (!studio.grants.length) {
    return <p className="text-xs text-content-muted">{t('studios.noPermissions')}</p>;
  }

  return (
    <div className="flex flex-col gap-3">
      <PermissionCounter added={direct} fromRoles={fromRoles} name={getFirstName(memberName)} />
      <PermissionTree nodes={studio.tree} draft={draft} mode="read" />
    </div>
  );
};

export default memo(StudioRowExpanded);
